import { toAbsoluteUrl } from "../../_theme/helpers";
import { memo } from "react";
import HeroSection from "./Components/HeroSection";
import { envConfig } from "../../utils/config";
import VideoWithFallback from "./Components/VideoWithFallback";
import { noAccessReason, useIsRightLocked } from "../modules/auth";

const OutcomeSection: React.FC = memo(() => {
    return (
        <div className="row d-flex flex-column-reverse flex-lg-row section-padding g-10 bg-white align-items-center m-0" id="introduction-section">
            <div className="col-md-8 px-10 px-sm-15 px-md-10 px-lg-20 px-xl-20  pe-lg-5 pe-xl-5">
                <div className="mb-10">
                    <p className="penoptic-evaluation-section-title mb-2">Meet EVE: Your Expert Infrastructure Artificial Intelligence</p>
                    <p className="section-content mt-5">
                        EVE is a cutting-edge Large Language Model based chatbot and AI agent designed to make South African government policies and frameworks more accessible, understandable, and actionable. Trained on a rich library of official government prescripts - including legislation, policies, implementation guidelines, and strategic plans - EVE bridges the gap between technical documents and practical understanding. Whether you’re a citizen, public servant, or project implementer, EVE delivers clear, instant responses tailored to your queries.
                    </p>
                </div>
                <div>
                    <p className="penoptic-evaluation-section-title mb-2">Powered by Policy, Built for Impact</p>
                    <p className="section-content mt-5">
                        Unlike generic AI tools, EVE is purpose-built to support decision-making within the context of Infrastructure development goals. EVE is trained in key prescripts such as the National Infrastructure Plan, National Development Plan, Growth for Jobs, WCSDF & PTLF, Western Cape Infrastructure Framework, and other sector priorities. EVE helps users unpack complex policies, clarify compliance requirements, and understand how specific programs align with broader government objectives. Trained to complete draft business cases – like to platform stuff and generate content for project documentation to lower cost and facilitate ease of doing business .
                    </p>
                </div>
            </div>
            <div className="col-md-4 text-center px-10 px-sm-15 px-md-10 px-lg-10 px-xl-20  ps-lg-5 ps-xl-5">
                <VideoWithFallback
                    videoSrc={`${envConfig.APP_MEDIA_URL}videos/public-pages/AI2.mp4`}
                    fallbackSrc={`${envConfig.APP_MEDIA_URL}images/public-pages/AI2.webp`}
                    alt="AI Background"
                />
            </div>
        </div>
    )
});

const GigaMapDiffSection: React.FC = memo(() => {
    return (
        <div className="row section-padding g-10 bg-white align-items-center g-10">
            <div className="col-md-12 px-10 px-sm-15 px-md-10 px-lg-20 px-xl-20">
                <VideoWithFallback
                    videoSrc={`${envConfig.APP_MEDIA_URL}videos/public-pages/AI4.mp4`}
                    fallbackSrc={`${envConfig.APP_MEDIA_URL}images/public-pages/AI4.webp`}
                    alt="AI Background"
                    videoClassName="h-100 w-100 w-xl-75 h-xl-75" 
                    className="d-flex  align-items-center justify-content-center"
                />
            </div>
        </div>
    )
});

const VisionSection: React.FC = memo(() => {
    return (
        <div className="row section-padding bg-white align-items-center">
            <div className="col-md-6 text-center px-10 px-sm-15 px-md-10 px-lg-20 px-xl-20 pe-lg-5 pe-xl-5">
                <VideoWithFallback
                    videoSrc={`${envConfig.APP_MEDIA_URL}videos/public-pages/AI3.mp4`}
                    fallbackSrc={`${envConfig.APP_MEDIA_URL}images/public-pages/AI3.webp`}
                    alt="AI Background"
                />
            </div>

            <div className="col-md-6 px-10 px-sm-15 px-md-10 px-lg-20 px-xl-20 ps-lg-5 ps-xl-5 mt-10 mt-lg-0">
                <div>
                    <p className="penoptic-evaluation-section-title mb-5">
                        Enabling Digitally Transparent Governance
                    </p>
                    <p className="section-content mb-5">
                        EVE plays a strategic role in promoting transparency,
                        knowledge-sharing, and smarter service delivery. EVE
                        turns dense regulatory frameworks into bite-sized,
                        understandable facts and insights, thereby facilitating ease of doing business while strengthening and supporting effective governance. As EVE continues to evolve, it
                        will become a cornerstone of adaptive digital governance,
                        empowering all users to navigate complex regulations.
                    </p>
                </div>
            </div>
        </div>
    );
});

// Main Component
const ArtificialInteligence: React.FC = () => {
    const isRightLocked = useIsRightLocked();
    return (
        <div className="overflow-y-auto overflow-x-hidden about-us bg-white">
            <HeroSection
                videoSrc={`${envConfig.APP_MEDIA_URL}videos/public-pages/AI.mp4`}
                fallbackImage={`${envConfig.APP_MEDIA_URL}images/public-pages/AI.webp`}
                title="Artificial Intelligence (EVE)"
                subtitle="Your Expert Infrastructure Artificial Intelligence"
                imageSrc={toAbsoluteUrl("media/images/DOIplatformInfrabotwhite.png")}
                imageAlt="Artificial Intelligence"
                imageClassName="w-150px"
                overlay
                disabledReason={isRightLocked('eve') ? noAccessReason('EVE') : undefined}
                onButtonClick={() => {
                    document
                        .querySelector(".chat-button")
                        ?.dispatchEvent(
                            new MouseEvent("click", {
                                bubbles: true,
                                cancelable: true,
                                view: window,
                            })
                        );
                }}
                scrollParentId="introduction-section"
            />
            <OutcomeSection />
            <VisionSection />
            <GigaMapDiffSection />
        </div>
    )
};

export default ArtificialInteligence;